import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as S from '../style'

export function UluleLogo(): React.ReactElement<any> {
  return (
    <Wrapper>
      <plume.logos.ulule.OwlOnlyLogo />
      <HiddenTitle>Ulule</HiddenTitle>
    </Wrapper>
  )
}

const Wrapper = styled.span`
  ${plume.logos.ulule.OwlOnlyLogo} {
    width: 31px;
    position: relative;
    top: 2px;
  }

  @media screen and ${S.CUSTOM_INTERMEDIATE_BREAKPOINT} {
    align-items: center;
    display: flex;

    ${plume.logos.ulule.OwlOnlyLogo} {
      height: 33px;
      width: 34px;
    }

    ${plume.logos.ulule.TextOnlyLogo} {
      align-self: baseline;
      height: 38px;
      margin-left: 4px;
      margin-bottom: 5px;
      width: 68px;
    }
  }

  @media screen and ${S.CUSTOM_INTERMEDIATE_BREAKPOINT} {
    ${plume.logos.ulule.OwlOnlyLogo} {
      top: 0;
    }
  }
`

const HiddenTitle = styled.span`
  left: 0;
  position: absolute;
  top: 0;
  visibility: hidden;
`
